// src/feed/VisitToFeedMount.tsx
//
// Headless component that runs feed-related background hooks for
// authenticated users — the visit-to-feed bridge plus the public-
// profile backfill. Mounted once at App level inside the auth-guard
// tree so the hooks run regardless of which tab is active. Does
// not render anything.

import React from 'react';
import { useVisitToFeedBridge } from './useVisitToFeedBridge';
import { useProfileBackfill } from '../profile/useProfileBackfill';

interface Props {
  isAuthenticated: boolean;
}

const Inner: React.FC = () => {
  // Hooks called unconditionally inside Inner; the parent gates
  // rendering, which gates the hook lifecycle.
  useVisitToFeedBridge();
  useProfileBackfill();
  return null;
};

export const VisitToFeedMount: React.FC<Props> = ({ isAuthenticated }) => {
  if (!isAuthenticated) return null;
  return <Inner />;
};
